import { createFileRoute } from '@tanstack/react-router';
import { SourceLinkGenerator } from '@/features/sources/components/SourceLinkGenerator/SourceLinkGenerator';

export const Route = createFileRoute('/_auth/sources/links')({
  component: SourcesLinksPage,
});

function SourcesLinksPage() {
  return <SourceLinkGenerator />;
}
